/* tslint:disable */
/* eslint-disable */
/**
 * API SPECS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RegisterRequestBody
 */
export interface RegisterRequestBody {
    /**
     * 
     * @type {string}
     * @memberof RegisterRequestBody
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterRequestBody
     */
    password?: string;
}

/**
 * Check if a given object implements the RegisterRequestBody interface.
 */
export function instanceOfRegisterRequestBody(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RegisterRequestBodyFromJSON(json: any): RegisterRequestBody {
    return RegisterRequestBodyFromJSONTyped(json, false);
}

export function RegisterRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegisterRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': !exists(json, 'email') ? undefined : json['email'],
        'password': !exists(json, 'password') ? undefined : json['password'],
    };
}

export function RegisterRequestBodyToJSON(value?: RegisterRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'password': value.password,
    };
}

